import { useState, useEffect, useCallback } from 'react';
import { communeAPI, Commune } from '../api/communes';

export const useCommunes = (wilayaCode?: string) => {
  const [communes, setCommunes] = useState<Commune[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Charger les communes d'une wilaya spécifique
  const loadCommunesByWilaya = useCallback(async (code: string) => {
    if (!code) {
      setCommunes([]);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      console.log('🔍 Chargement des communes pour la wilaya:', code);
      const data = await communeAPI.getByWilaya(code);
      console.log('📊 Communes chargées:', data.length);
      setCommunes(data);
    } catch (error) {
      console.error('❌ Erreur lors du chargement des communes:', error);
      setError('Erreur lors du chargement des communes');
      setCommunes([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Rechercher des communes par nom
  const searchCommunes = useCallback(async (searchTerm: string, limit: number = 20) => {
    if (!searchTerm || searchTerm.length < 2) {
      setCommunes([]);
      return [];
    }

    setIsLoading(true);
    setError(null);
    try {
      console.log('🔍 Recherche de communes:', searchTerm);
      const data = await communeAPI.search(searchTerm, limit);
      console.log('📊 Résultats de recherche:', data.length);
      setCommunes(data);
      return data;
    } catch (error) {
      console.error('❌ Erreur lors de la recherche de communes:', error);
      setError('Erreur lors de la recherche');
      setCommunes([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Charger automatiquement si wilayaCode est fourni
  useEffect(() => {
    if (wilayaCode) {
      loadCommunesByWilaya(wilayaCode);
    }
  }, [wilayaCode, loadCommunesByWilaya]);

  return {
    communes,
    isLoading,
    error,
    loadCommunesByWilaya,
    searchCommunes,
  };
};